export const FETCH_CONTRACT_DATA_SUCCESS = 'FETCH_CONTRACT_DATA_SUCCESS';

export const FETCH_CONTRACT_DATA_FAILURE = 'FETCH_CONTRACT_DATA_FAILURE';